export const moedas = {
  Ethereum: [
    // {
    //   nome: "ETH",
    //   contrato: "0x0",
    //   decimals: 18,
    // },
    {
      nome: "WETH",
      contrato: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
      decimals: 18,
    },
    {
      nome: "WBTC",
      contrato: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
      decimals: 8,
    },
    {
      nome: "USDT",
      contrato: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      decimals: 6,
    },
    {
      nome: "USDC",
      contrato: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      decimals: 6,
    },
    {
      nome: "DAI",
      contrato: "0x6b175474e89094c44da98b954eedeac495271d0f",
      decimals: 18,
    },
  ],
  Arbitrum: [
    // {
    //   nome: "ETH",
    //   contrato: "0x0",
    //   decimals: 18,
    // },
    {
      nome: "WETH",
      contrato: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
      decimals: 18,
    },
    {
      nome: "WBTC",
      contrato: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      decimals: 8,
    },
    {
      nome: "USDT",
      contrato: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      decimals: 6,
    },
    {
      nome: "USDC",
      contrato: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      decimals: 6,
    },
    {
      nome: "DAI",
      contrato: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
      decimals: 18,
    },
  ],
  Polygon: [
    // {
    //   nome: "MATIC",
    //   contrato: "0x0",
    //   decimals: 18,
    // },
    {
      nome: "WMATIC",
      contrato: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
      decimals: 18,
    },
    {
      nome: "WETH",
      contrato: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
      decimals: 18,
    },
    {
      nome: "WBTC",
      contrato: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
      decimals: 8,
    },
    {
      nome: "USDT",
      contrato: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
      decimals: 6,
    },
    {
      nome: "USDC",
      contrato: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
      decimals: 6,
    },
    {
      nome: "USDC.e",
      contrato: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
      decimals: 6,
    },
    {
      nome: "DAI",
      contrato: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
      decimals: 18,
    },
  ],
  Binance: [
    // {
    //   nome: "BNB",
    //   contrato: "0x0",
    //   decimals: 18,
    // },
    {
      nome: "WBNB",
      contrato: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
      decimals: 18,
    },
    {
      nome: "ETH",
      contrato: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
      decimals: 18,
    },
    {
      nome: "BTCB",
      contrato: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
      decimals: 18,
    },
    {
      nome: "USDT",
      contrato: "0x55d398326f99059fF775485246999027B3197955",
      decimals: 18,
    },
    {
      nome: "USDC",
      contrato: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      decimals: 18,
    },
    {
      nome: "DAI",
      contrato: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
      decimals: 18,
    },
  ],
  Base: [
    {
      nome: "ETH",
      contrato: "0x0",
      decimals: 18,
    },
    {
      nome: "USDC",
      contrato: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      decimals: 18,
    },
    {
      nome: "USDT",
      contrato: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
      decimals: 6,
    },
    {
      nome: "DAI",
      contrato: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
      decimals: 18,
    },
  ],
  Berachain: [
    {
      nome: "BERA",
      contrato: "0x0",
      decimals: 18,
    },
    {
      nome: "WBERA",
      contrato: "0x6969696969696969696969696969696969696969",
      decimals: 18,
    },
  ],
  Neurochain: [
    {
      nome: "NCN",
      contrato: "0x0",
      decimals: 18,
    },
    {
      nome: "WNCN",
      contrato: "0x548fEb5483a6ecb3CBEDff65ed7ad960DcFC26b2",
      decimals: 18,
    },
  ],
  Avalanche:[
    {
      nome: "WAVAX",
      contrato: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      decimals: 18,
    },
    {
      nome: "WETH",
      contrato: "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab",
      decimals: 18,
    },
    {
      nome: "WBTC",
      contrato: "0x50b7545627a5162f82a992c33b87adc75187b218",
      decimals: 8,
    },
    {
      nome: "USDT",
      contrato: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
      decimals: 6,
    },
    {
      nome: "USDC",
      contrato: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
      decimals: 6,
    },
    {
      nome: "DAI",
      contrato: "0xd586e7f844cea2f87f50152665bcbc2c279d8d70",
      decimals: 18,
    },
  ]
};
